import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import {LanguageSharp} from "@mui/icons-material";
import AssessmentIcon from '@mui/icons-material/Assessment';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import TuneIcon from '@mui/icons-material/Tune';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import FaceIcon from '@mui/icons-material/Face';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MapIcon from '@mui/icons-material/Map';
import SyncIcon from '@mui/icons-material/Sync';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

export const iconMap = {
  DashboardIcon: <DashboardIcon />,
  SettingsIcon: <SettingsIcon />,
  PersonIcon: <PersonIcon />,
  LanguageSharpIcon: <LanguageSharp />,
  ReportsIcon: <AssessmentIcon />,
  DeviceIcon: <AdUnitsIcon />,
  TuneIcon: <TuneIcon />,
  LocationPinIcon: <LocationPinIcon />,
  ReceiptLongIcon: <ReceiptLongIcon />,
  FaceIcon: <FaceIcon />,
  FactCheckIcon: <FactCheckIcon />,
  CalendarMonthIcon: <CalendarMonthIcon />,
  EventNoteIcon: <EventNoteIcon />,
  MapIcon: <MapIcon />,
  SyncIcon: <SyncIcon />,
  AdminPanelSettingsIcon: <AdminPanelSettingsIcon />,

};
